// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._4JtpuS65x{display:flex;flex-direction:row;flex-wrap:nowrap;overflow-x:auto;width:100%;height:100%;-webkit-overflow-scrolling:touch;-ms-overflow-style:none;-ms-scroll-snap-type:x mandatory;scroll-snap-type:x mandatory;-ms-scroll-snap-destination:0% 100%;scroll-snap-destination:0% 100%;-ms-scroll-snap-points-x:repeat(100%);scroll-snap-points-x:repeat(100%)}._4JtpuS65x::-webkit-scrollbar{background:transparent}._4JtpuS65x>*{width:inherit;height:inherit;flex:0 0 auto;box-sizing:border-box;padding:8px;scroll-snap-align:start}._68Fj4jWQx{display:flex;flex-direction:row;justify-content:center}._2MLlKpNvx{width:16px;height:16px}._2MLlKpNvx:before{content:\"\";display:block;width:8px;height:8px;margin:4px;border-radius:50%;background:rgba(0,0,0,0.2)}._2MLlKpNvx._7jKwzuGUx:before{background:rgba(0,0,0,0.6)}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"carousel": "_4JtpuS65x",
	"indicator-dots": "_68Fj4jWQx",
	"indicatorDots": "_68Fj4jWQx",
	"indicator-dot": "_2MLlKpNvx",
	"indicatorDot": "_2MLlKpNvx",
	"selected": "_7jKwzuGUx"
};
module.exports = exports;
